import { render, staticRenderFns } from "./LotesList2.vue?vue&type=template&id=9afdaba6&"
import script from "./LotesList2.vue?vue&type=script&lang=js&"
export * from "./LotesList2.vue?vue&type=script&lang=js&"
import style0 from "./LotesList2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9afdaba6', component.options)
    } else {
      api.reload('9afdaba6', component.options)
    }
    module.hot.accept("./LotesList2.vue?vue&type=template&id=9afdaba6&", function () {
      api.rerender('9afdaba6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/LotesList2.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/LotesList2.vue
// module id = KV+o
// module chunks = 0